module.exports = __webpack_public_path__ + "static/alarmanlagen-angebotsvergleich-desktop-9f26a7e7f7124718898723f2ca891175.jpg";